module.exports = __webpack_public_path__ + "img/en.f495fa84.png";